module.exports = __webpack_public_path__ + "static/media/LancamentosFinanceiros1.93e9ff2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancLancamentosFinanceiros/LancamentosFinanceiros1.png
// module id = 2150
// module chunks = 0